(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["Filter-Collection2"] && !Shopify.designMode) return;
  try {
    
    document.addEventListener("DOMContentLoaded", function () {
        const products = document.querySelectorAll('.filter-collection-products');

        let inStock = 0;
        let outStock = 0;

        products.forEach(product => {
            if (product.dataset.available === "true") {
            inStock++;
            } else {
            outStock++;
            }
        });

        document.querySelector('#inStockCount').innerText = inStock;
        document.querySelector('#outOfStockCount').innerText = outStock;
    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["The-Kuda-Running-Info"] && !Shopify.designMode) return;
  try {
    
    document.addEventListener("DOMContentLoaded", function () {
        const runningText = document.querySelector(".running-info-h3");

        if (!runningText) return;

        let position = -runningText.offsetWidth;

        function animateText() {
        position += 2;

        if (position > window.innerWidth) {
            position = -runningText.offsetWidth;
        }

        runningText.style.transform = `translateX(${position}px)`;

        requestAnimationFrame(animateText);
        }

        animateText();
    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["flash-sales-slider"] && !Shopify.designMode) return;
  try {
    
    const slider = document.querySelector('.bot-flash-sales');
    const nextBtn = document.querySelector('.slide-next-flash');
    const prevBtn = document.querySelector('.slide-prev-flash');

    const scrollStep = 320;

    function updateButtons() {
        const maxScrollLeft = slider.scrollWidth - slider.clientWidth;

        // if naa sa pinaka left
        if (slider.scrollLeft <= 0) {
            prevBtn.style.cursor = 'not-allowed';
            prevBtn.style.opacity = '0.5';
        } else {
            prevBtn.style.cursor = 'pointer';
            prevBtn.style.opacity = '1';
        }

        // if naa sa pinaka right
        if (slider.scrollLeft >= maxScrollLeft - 5) {
            nextBtn.style.cursor = 'not-allowed';
            nextBtn.style.opacity = '0.5';
        } else {
            nextBtn.style.cursor = 'pointer';
            nextBtn.style.opacity = '1';
        }
    }

    // click events
    nextBtn.addEventListener('click', () => {
        slider.scrollBy({
            left: scrollStep,
            behavior: 'smooth'
        });

        setTimeout(updateButtons, 300);
    });

    prevBtn.addEventListener('click', () => {
        slider.scrollBy({
            left: -scrollStep,
            behavior: 'smooth'
        });

        setTimeout(updateButtons, 300);
    });

    // detect manual scroll (important!)
    slider.addEventListener('scroll', updateButtons);

    // initial check
    updateButtons();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-tabs"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
const container = document.querySelector('.related-products-container');
const products = document.querySelectorAll('.related-product');
const prevBtn = document.querySelector('.thumb-prev-relatedProducts');
const nextBtn = document.querySelector('.thumb-next-relatedProducts');

const visibleCount = 3; // show 3 products at a time
let currentIndex = 0;

function updateSlider() {
    const totalProducts = products.length;
    const translateX = -(currentIndex * (100 / visibleCount));
    container.style.transform = `translateX(${translateX}%)`;
}

nextBtn.addEventListener('click', () => {
    const totalProducts = products.length;
    currentIndex = (currentIndex + 1) % totalProducts;
    updateSlider();
});

prevBtn.addEventListener('click', () => {
    const totalProducts = products.length;
    currentIndex = (currentIndex - 1 + totalProducts) % totalProducts;
    updateSlider();
});

updateSlider(); // initialize
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["slider-banner2-thekuda"] && !Shopify.designMode) return;
  try {
    
    const slidesContent = document.querySelectorAll('.slide-inner-content');
    const slidesBg = document.querySelectorAll('.slide-item-bg');
    const prevBtn = document.querySelector('.slide-prev');
    const nextBtn = document.querySelector('.slide-next');
    const dots = document.querySelectorAll('.sliderBott-dot');

    const progressCircle = document.querySelector('.progress');
    const circleBtn = document.getElementById("circle");
    const icon = document.getElementById("icon");

    let currentIndex = 0;
    let sliderInterval;
    let progressInterval;
    let isPlaying = true;

    const intervalTime = 5000; // per slide
    const totalSlides = slidesContent.length;
    const totalCycleTime = intervalTime * totalSlides;

    let elapsedTime = 0;

    /* ================= SLIDE ================= */

    function showSlide(index) {
        slidesContent.forEach(s => s.classList.remove('active'));
        slidesBg.forEach(b => b.classList.remove('active'));
        dots.forEach(d => d.classList.remove('active'));

        slidesContent[index].classList.add('active');
        slidesBg[index].classList.add('active');
        dots[index].classList.add('active');
    }

    function nextSlide() {
        currentIndex = (currentIndex + 1) % totalSlides;
        showSlide(currentIndex);

        // RESET progress kung balik sa slide 1
        if (currentIndex === 0) {
            elapsedTime = 0;
        }
    }

    function prevSlide() {
        currentIndex = (currentIndex - 1 + totalSlides) % totalSlides;
        showSlide(currentIndex);
    }

    /* ================= AUTO SLIDER ================= */

    function startSlider() {
        clearInterval(sliderInterval);
        sliderInterval = setInterval(nextSlide, intervalTime);
    }

    /* ================= SMOOTH PROGRESS ================= */

    const radius = 20;
    const circumference = 2 * Math.PI * radius;

    progressCircle.style.strokeDasharray = circumference;
    progressCircle.style.strokeDashoffset = circumference;

    function startProgress() {
        clearInterval(progressInterval);

        progressInterval = setInterval(() => {
            elapsedTime += 100;

            let progressPercent = elapsedTime / totalCycleTime;

            if (progressPercent >= 1) {
                progressPercent = 1;
            }

            let offset = circumference - (progressPercent * circumference);
            progressCircle.style.strokeDashoffset = offset;

        }, 100); // smooth (every 0.1s)
    }

    /* ================= EVENTS ================= */

    nextBtn.addEventListener('click', () => {
        nextSlide();
        startSlider();
    });

    prevBtn.addEventListener('click', () => {
        prevSlide();
        startSlider();
    });

    dots.forEach((dot, i) => {
        dot.addEventListener('click', () => {
            currentIndex = i;
            showSlide(currentIndex);

            // adjust time based sa gi click nga slide
            elapsedTime = i * intervalTime;

            startSlider();
        });
    });

    /* ================= PLAY / PAUSE ================= */

    icon.classList.add("pause");

    circleBtn.addEventListener("click", () => {
        isPlaying = !isPlaying;

        if (isPlaying) {
            icon.classList.remove("play");
            icon.classList.add("pause");

            startSlider();
            startProgress();

        } else {
            icon.classList.remove("pause");





            icon.classList.add("play");

            clearInterval(sliderInterval);
            clearInterval(progressInterval);
        }
    });

    /* ================= INIT ================= */

    showSlide(currentIndex);
    startSlider();
    startProgress();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["slider-banner2-thekuda2"] && !Shopify.designMode) return;
  try {
    

document.addEventListener("DOMContentLoaded", function () {

  const slider = document.querySelector(".hero-slider-new-two");

  if (!slider) return;


  const slides = slider.querySelectorAll(".hero-slide");

  const nextButton = slider.querySelector(".slide-next");

  const prevButton = slider.querySelector(".slide-prev");

  const dotsContainer = slider.querySelector(".slider-dots");


  if (!slides.length || !dotsContainer) return;


  let currentSlide = 0;

  let isAnimating = false;

  let autoPlay;


  const slideDuration = 5000;

  const animationDuration = 800;


  /* =========================
     CREATE DOTS
  ========================= */

  slides.forEach(function (slide, index) {

    const dot = document.createElement("button");

    dot.type = "button";

    dot.classList.add("slider-dot");

    dot.setAttribute(
      "aria-label",
      "Go to slide " + (index + 1)
    );

    dot.setAttribute(
      "role",
      "tab"
    );


    if (index === 0) {

      dot.classList.add("active");

      dot.setAttribute("aria-selected", "true");

    } else {

      dot.setAttribute("aria-selected", "false");

    }


    dot.addEventListener("click", function () {

      if (index > currentSlide) {

        goToSlide(index, "next");

      } else if (index < currentSlide) {

        goToSlide(index, "previous");

      }

    });


    dotsContainer.appendChild(dot);

  });


  const dots =
    dotsContainer.querySelectorAll(".slider-dot");


  /* =========================
     SLIDE FUNCTION
  ========================= */

  function goToSlide(newIndex, direction) {

    if (
      isAnimating ||
      newIndex === currentSlide ||
      newIndex < 0 ||
      newIndex >= slides.length
    ) {
      return;
    }


    isAnimating = true;


    const current =
      slides[currentSlide];

    const next =
      slides[newIndex];


    /* =========================
       SET START POSITION
    ========================= */

    if (direction === "next") {

      next.style.transform =
        "translateY(100%)";

    } else {

      next.style.transform =
        "translateY(-100%)";

    }


    next.style.transition = "none";

    next.classList.add("active");


    /* FORCE REFLOW */

    next.offsetHeight;


    /* =========================
       ENABLE TRANSITION
    ========================= */

    current.style.transition =
      "transform " +
      animationDuration +
      "ms cubic-bezier(0.77, 0, 0.175, 1)";

    next.style.transition =
      "transform " +
      animationDuration +
      "ms cubic-bezier(0.77, 0, 0.175, 1)";


    /* =========================
       MOVE CURRENT SLIDE
    ========================= */

    if (direction === "next") {

      current.style.transform =
        "translateY(-100%)";

    } else {

      current.style.transform =
        "translateY(100%)";

    }


    /* =========================
       MOVE NEW SLIDE INTO VIEW
    ========================= */

    next.style.transform =
      "translateY(0)";


    /* =========================
       UPDATE DOTS
    ========================= */

    dots.forEach(function (dot) {

      dot.classList.remove("active");

      dot.setAttribute(
        "aria-selected",
        "false"
      );

    });


    dots[newIndex].classList.add("active");

    dots[newIndex].setAttribute(
      "aria-selected",
      "true"
    );


    currentSlide = newIndex;


    /* =========================
       CLEANUP
    ========================= */

    setTimeout(function () {

      slides.forEach(function (slide, index) {

        if (index !== currentSlide) {

          slide.classList.remove("active");

          slide.style.transition = "none";

          slide.style.transform =
            "translateY(100%)";

        }

      });


      isAnimating = false;

    }, animationDuration);


    restartAutoPlay();

  }


  /* =========================
     NEXT SLIDE
  ========================= */

  function nextSlide() {

    let nextIndex =
      currentSlide + 1;


    if (nextIndex >= slides.length) {

      nextIndex = 0;

    }


    goToSlide(
      nextIndex,
      "next"
    );

  }


  /* =========================
     PREVIOUS SLIDE
  ========================= */

  function previousSlide() {

    let previousIndex =
      currentSlide - 1;


    if (previousIndex < 0) {

      previousIndex =
        slides.length - 1;

    }


    goToSlide(
      previousIndex,
      "previous"
    );

  }


  /* =========================
     BUTTONS
  ========================= */

  if (nextButton) {

    nextButton.addEventListener(
      "click",
      nextSlide
    );

  }


  if (prevButton) {

    prevButton.addEventListener(
      "click",
      previousSlide
    );

  }


  /* =========================
     AUTOPLAY
  ========================= */

  function startAutoPlay() {

    clearInterval(autoPlay);

    autoPlay = setInterval(
      function () {

        nextSlide();

      },
      slideDuration
    );

  }


  function restartAutoPlay() {

    clearInterval(autoPlay);

    startAutoPlay();

  }


  /* =========================
     MOUSE WHEEL
  ========================= */




  /* =========================
     TOUCH SWIPE
  ========================= */

  let touchStartY = 0;

  let touchEndY = 0;


  slider.addEventListener(
    "touchstart",
    function (event) {

      touchStartY =
        event.touches[0].clientY;

    },
    {
      passive: true
    }
  );


  slider.addEventListener(
    "touchend",
    function (event) {

      touchEndY =
        event.changedTouches[0].clientY;


      const difference =
        touchStartY - touchEndY;


      if (
        Math.abs(difference) < 50
      ) {
        return;
      }


      if (difference > 0) {

        nextSlide();

      } else {

        previousSlide();

      }

    },
    {
      passive: true
    }
  );


  /* =========================
     START SLIDER
  ========================= */

  startAutoPlay();

});


  } catch(e) { console.error(e); }
})();
})();
